import create from "zustand";

export const [useStore] = create((set) => ({
  imageGalleryFilter: "",
  setGlobalImageGalleryFilter: (curFilter) =>
    set({ imageGalleryFilter: curFilter }),
}));
